export default "__VITE_ASSET__B87wdB_E__"